import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Stack, styled, Typography } from '@mui/material';
import { palette } from '../../../../../theme/default';

const Wrapper = styled(Button)(({ theme, isActive, stateCode }) => ({
  position: 'relative',
  padding: '0 24px',
  border: `1px solid ${theme.palette.additional.lines}`,
  borderRadius: '16px',
  textTransform: 'none',
  justifyContent: 'flex-start',
  minHeight: '230px',
  width: '328px',
  maxHeight: stateCode === 'NV' ? '235px' : '172px',
  ...(isActive && { background: theme.palette.text.disabled }),

  '&:hover': {
    background: theme.palette.text.disabled,
  },
}));

const DashboardLegalAssistantCard = ({
  title,
  icon,
  count,
  isActive,
  onClick,
  isDisabled,
  base,
  stateCode,
}) => {
  return (
    <Wrapper
      isActive={isActive}
      onClick={onClick}
      disableRipple
      disabled={isDisabled}
      stateCode={stateCode}
    >
      <Stack justifyContent="center" gap="16px" height="100%">
        <Box display="flex" alignItems="center">
          {icon}
          <Typography
            variant="h5"
            marginLeft={1}
            color={palette.text.primary}
            sx={{ textAlign: 'start' }}
          >
            {title}
          </Typography>
        </Box>
        <Box color={palette.text.secondary} display="inline" textAlign="left">
          <Typography fontWeight={700} fontSize={32} component="span" paddingRight={1}>
            {count}
          </Typography>
          <Typography component="span" variant="bodyL500">
            {`${base}${count === 1 ? '' : 's'}`}
          </Typography>
        </Box>
      </Stack>
    </Wrapper>
  );
};

DashboardLegalAssistantCard.propTypes = {
  title: PropTypes.string.isRequired,
  count: PropTypes.number.isRequired,
  icon: PropTypes.node,
  isActive: PropTypes.bool,
  isDisabled: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  base: PropTypes.string.isRequired,
  stateCode: PropTypes.string.isRequired,
};

DashboardLegalAssistantCard.defaultProps = { icon: null, isActive: false, isDisabled: false };

export default DashboardLegalAssistantCard;
